import React from "react";
import ManageTags from "components/Tags/ManageTags";
import { Container } from "reactstrap";
import useUser from "api/api-hooks/auth/useUser";

export const AccountTags = () => {
  const { user } = useUser();

  return (
    <Container fluid className="mt-4">
      <ManageTags
        title="My Tags"
        description="Create and manage custom tags associated with your account. Custom tags that you create will only be visible by you."
        scope={{ Type: "Person", PersonID: user.id }}
      />
    </Container>
  );
};
